import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCountdownNotificationComponent } from './countdown-notification.component';
import { FiCountdownNotificationService } from './countdown-notification.service';

@NgModule({
    imports: [CommonModule],
    declarations: [FiCountdownNotificationComponent],
    exports: [FiCountdownNotificationComponent],
    providers: [FiCountdownNotificationService],
})
export class FiCountdownNotificationModule {}
